export default function isStringWithSpecial(values, value) {
  const regex = /^[-@.,'/#&+!(){}\d\s\w\uAC00-\uD7AF\u3040-\u30FF\u4e00-\u9FFF\u00C0-\u017F\u0430-\u044f]*$/iu;
  return regex.test(value || '');
}
